// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-stripe_68a61099 {
  display: flex;
  align-items: center;
  height: inherit;
  justify-content: space-between;
}
.pagination-stripe_68a61099 > * {
  margin-left: 2rem;
}
.pagination-stripe_68a61099 > :first-child {
  margin-left: 0;
}
.pagination-stripe_small-container_68a61099 {
  flex-grow: 1;
}
.pagination-stripe_small_68a61099 {
  height: 2.667rem;
}
.pagination-stripe_no-pagination_68a61099 {
  justify-content: flex-end;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination-stripe": `pagination-stripe_68a61099`,
	"pagination-stripe_small-container": `pagination-stripe_small-container_68a61099`,
	"pagination-stripe_small": `pagination-stripe_small_68a61099`,
	"pagination-stripe_no-pagination": `pagination-stripe_no-pagination_68a61099`
};
export default ___CSS_LOADER_EXPORT___;
